import { lazy } from 'react';

const modalEntities = {
  createDossier: lazy(() => import('./createDossier/CreateDossierModal')),
  sendCommunication: lazy(() => import('./sendCommunicationModal/SendCommunicationModal')),
  sendCertifiedDocument: lazy(() => import('./SendCertifiedDocumentModal')),
  deleteNotary: lazy(() => import('./DeleteNotaryModal')),
  contactDocuments: lazy(() => import('./ContactDocumentsModal')),
  contactsAllNotariesSearchFilterModal: lazy(
    () => import('./ContactsAllNotariesSearchFilterModal'),
  ),
  documentOptionsBottomSheet: lazy(() => import('../bottomSheets/DocumentOptionsBottomSheet')),
  citizenListOptionsBottomSheet: lazy(
    () => import('../bottomSheets/CitizenListOptionsBottomSheet'),
  ),
  notaryListOptionsBottomSheet: lazy(() => import('../bottomSheets/NotaryListOptionsBottomSheet')),
  notaryDetails: lazy(() => import('./NotaryDetailsModal')),
  studyDetails: lazy(() => import('./StudyDetailsModal')),
  vaultTransferOptionsBottomSheet: lazy(
    () => import('../bottomSheets/VaultTransferOptionsBottomSheet'),
  ),
  claimVault: lazy(() => import('./ClaimVaultModal')),
  passClaimedVault: lazy(() => import('./PassClaimedVaultModal')),
  passClaimedVaultConfirmation: lazy(() => import('./PassClaimedVaultModalConfirmation')),
  connectivePluginNotInstalled: lazy(() => import('./ConnectivePluginNotInstalledModal')),
  abortCertification: lazy(() => import('./AbortCertificationModal')),
  certificationFailed: lazy(() => import('./CertificationFailedModal')),
  deceasedContact: lazy(() => import('./DeceasedContactModal')),
  heirDetails: lazy(() => import('./HeirDetailsModal')),
  addHeir: lazy(() => import('./AddHeirModal')),
  editHeir: lazy(() => import('./EditHeirModal')),
  transferVaultConfirmation: lazy(() => import('./TransferVaultConfirmationModal')),
  rejectVaultTransferConfirmation: lazy(() => import('./RejectTransferVaultConfirmationModal')),
  tooBigToCertify: lazy(() => import('./TooBigToCertifyModal')),
  documentExtendTrashDate: lazy(() => import('./DocumentExtendTrashDateModal')),
  manageStructuredCommunicationSlots: lazy(
    () => import('./ManageStructuredCommunicationSlotsModal'),
  ),
  addEmail: lazy(() => import('./AddEmailModal')),
  discardEmailSubscriptions: lazy(() => import('./DiscardEmailSubscriptionsModal')),
};

export default modalEntities;
